import React, { useCallback, useState, useRef, useEffect } from 'react';
import axios from '../axios';
import FeedItem from '../userfeeds/userfeed_item';

const OthersUserfeedList = ({currentUser, companyId, hashedCompanyId, circleId}) => {
  const [userfeeds, setUserFeeds] = useState([]);
  const [isLoadingNextList, setIsLoadingNextList] = useState(false);
  const [isLastPage, setIsLastPage] = useState(false);
  const [page, setPage] = useState(1);
  const ancLastItemRef = useRef(null);
  const isEnableNextLoad = useRef(true);

  // スクロール時
  const loadNextList = useCallback(() => {
    if (isLoadingNextList || isLastPage) {
      return;
    }
    setIsLoadingNextList(true);
    let url = '';
    if (companyId && circleId) {
      url =`/api/userfeeds/community/circles?company_id=${companyId}&page=${page}`
    } else if (companyId && circleId === null) {
      url = `/api/userfeeds/community/?company_id=${companyId}&page=${page}`;
    } else if (!companyId && circleId) {
      url = `/api/userfeeds?circle_id=${circleId}&page=${page}`;
    } else {
      url = `/api/userfeeds?page=${page}`;
    }
    
    axios.get(url).then((res) => {
      setUserFeeds((prev) => [...prev, ...res.data.userfeeds]);
      setPage((prev) => prev + 1);
      setIsLoadingNextList(false);
      setIsLastPage(res.data.isLastPage);
    });
  }, [page, isLoadingNextList, isLastPage, setIsLoadingNextList, companyId]);

  useEffect(() => {
    loadNextList();
  }, []);

  const handleScrollEvent = useCallback(() => {
    const ancPosition = ancLastItemRef.current.offsetTop;
    const scrolled = $(window).scrollTop();
    if (
      scrolled > ancPosition - 1000 &&
      scrolled < ancPosition &&
      isEnableNextLoad.current
    ) {
      isEnableNextLoad.current = false;
      loadNextList();
    }
  }, [ancLastItemRef, isEnableNextLoad, loadNextList]);

  useEffect(() => {
    if (isLoadingNextList) {
      isEnableNextLoad.current = false;
    } else {
      isEnableNextLoad.current = true;
    }

    if (typeof window !== 'undefined') {
      if (isLastPage) {
        window.removeEventListener('scroll', handleScrollEvent);
      } else {
        window.addEventListener('scroll', handleScrollEvent);
      }

      return () => {
        window.removeEventListener('scroll', handleScrollEvent);
      };
    }
  }, [isLastPage, handleScrollEvent]);



  return (
    <div className="container col-md-10 col-lg-8 bg-gray my-4">
      <div className="row">
        {userfeeds.map((userfeed, index) => (
          <FeedItem
          key={`${userfeed.id}_${index}`}
          currentUser={currentUser}
          userfeed={userfeed}
          hashedCompanyId={hashedCompanyId}
          />
        ))}
        {isLoadingNextList && (
          <div className="mx-auto py-4">
          <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
          </div>
          </div>
        )}
        <div id="ancLastItem" ref={ancLastItemRef} />
      </div>
    </div>
  );
}

export default OthersUserfeedList;